import resources from '@/crud/form/form'

import data from './data'
import methods from './methods'
import validations from './validations'
import components from './components'

export default {
  data,
  methods,
  validations,
  components,
  mixins: [resources],
  resourcePath: '/v1/auth/register'
}



// WEBPACK FOOTER //
// ./src/app/auth/register/dweller/resources/index.js